export default "__VITE_ASSET__DxjB914m__"